export default useKeyValuePairsForm;

function useKeyValuePairsForm(keyValuePairs, updateKeyValuePairs) {
  const addKeyValuePair = (keyValuePair) => {
    const { key, value } = keyValuePair;
    updateKeyValuePairs({ ...keyValuePairs, [key]: value });
  };

  const removeKeyValuePair = (key: string) => {
    const { [key]: _, ...rest } = keyValuePairs;
    updateKeyValuePairs({ ...rest });
  };

  const updateKeyValuePair = (currentKey, updatedKeyValuePair) => {
    const { key, value } = updatedKeyValuePair;
    const { [currentKey]: _, ...rest } = keyValuePairs;
    const updatedQueryParams = {
      ...rest,
      [key]: value,
    };

    updateKeyValuePairs(updatedQueryParams);
  };

  return {
    addKeyValuePair,
    removeKeyValuePair,
    updateKeyValuePair,
  };
}
